module.exports = __webpack_public_path__ + "static/ateneu-0b714469df644dd1e8727f3be171c2a5.jpg";